// Bhairava Spa — interacciones
(function () {
  // Header scroll state
  var header = document.getElementById('siteHeader');
  function onScroll() {
    if (!header) return;
    if (window.scrollY > 40) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Mobile nav
  var toggle = document.getElementById('navToggle');
  var nav = document.getElementById('nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
      toggle.classList.toggle('open');
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('open');
        toggle.classList.remove('open');
      });
    });
  }

  // Ritual modal
  var modal = document.getElementById('ritualModal');
  if (modal) {
    var rm = {
      badge: document.getElementById('rmBadge'),
      name: document.getElementById('rmName'),
      meta: document.getElementById('rmMeta'),
      price: document.getElementById('rmPrice'),
      desc: document.getElementById('rmDesc'),
      reserve: document.getElementById('rmReserve')
    };
    var lastFocus = null;

    function openModal(card) {
      lastFocus = card;
      rm.badge.textContent = card.getAttribute('data-badge') || '';
      rm.name.textContent = card.getAttribute('data-name') || '';
      rm.meta.textContent = card.getAttribute('data-duration') || '';
      rm.price.textContent = card.getAttribute('data-price') || '';
      rm.desc.textContent = card.getAttribute('data-desc') || '';
      rm.reserve.setAttribute('href', card.getAttribute('data-wa') || '#');
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
      rm.reserve.focus();
    }
    function closeModal() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
      if (lastFocus) lastFocus.focus();
    }

    document.querySelectorAll('.js-ritual').forEach(function (card) {
      card.addEventListener('click', function () { openModal(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(card); }
      });
    });
    modal.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
    });
  }

  // Reveal on scroll
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 4, 3) * 0.08) + 's';
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }
})();
